<template>
  <div class="member-ebook">
    <List
      class="list"
      ref="list"
      url="/api/app/myEbook"
      :search="{}"
      :limit="10"
      :alwaysShowPager="true"
    >
      <template v-slot="{ list }">
        <div class="ebook-list clearfix">
          <EbookItem
            v-for="item in list"
            :key="item.id"
            :item="item"
          ></EbookItem>
        </div>
        <Empty
          v-if="list.length == 0"
          class="empty"
          title="暂无电子书要阅读！"
        />
      </template>
    </List>
  </div>
</template>
<script>
import List from "@/components/List.vue";
import EbookItem from "./components/EbookItem.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";

export default {
  name: "MemberEbooks",
  components: { List, EbookItem },
  data() {
    return {
      // list: [],
    };
  },
  async mounted() {
    triggerLoaded(this);
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
/deep/ .pager {
  margin: 0;
  padding: 0 24px 24px 0 !important;
  background: #ffffff;
  text-align: right;
}
.ebook-list {
  padding: 24px;
  background: #ffffff;
}
</style>
